import { Component, OnInit, Injector, ChangeDetectionStrategy } from "@angular/core";
import { GenericBasicGUI } from "src/model/class/component classes/generic-basic-gui";

@Component({
    selector: "app-shape",
    templateUrl: "./shape.component.html",
    styleUrls: ["./shape.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShapeComponent extends GenericBasicGUI implements OnInit {
  public styles = {
    "--opacity": "1",
    "pointer-events": "none",
    "--background": "white",
    overflow: "hidden",
  };

  public stylesChild = {};

  /**
   * Giorgia -
   * @param injector The injector param is used by the parent classes to inject the services that they needed:
   * using this trick if the parent classes needed some specific service I don't need to inject them here
   * but I can do the injection in the specific class.
   */
  constructor(injector: Injector) {
    super(injector);
  }

  /**
   * Giorgia - Set the first value of the text: used only as attempt to check if I can control the html code
   */
  ngOnInit() {
    [this.styles, this.stylesChild] = super.HandleProperties(
      this.styles,
      this.stylesChild
    );
  }

  ngOnDestroy() {
    this.onDestroyChildren();
  }

}
